import { OptionType } from 'src/apps/dashboard/components/navigation-menu/NavigationMenu';

import { BusinessUnit } from '../types/DashboardTypes';

/**
 * Convert business units to OptionType format for NavigationMenu
 * If selectedUnitId is provided, the selected unit will be placed at the top of the list
 */
export const formatBusinessUnitsForSelect = (
	businessUnits: BusinessUnit[],
	selectedUnitId?: string | null
): OptionType[] => {
	const options = businessUnits.map((unit) => ({
		value: unit.id,
		label: unit.name
	}));

	const selectedIndex = options.findIndex((option) => option.value === selectedUnitId);
	if (selectedIndex > 0) {
		const selected = options[selectedIndex];
		return [selected, ...options.slice(0, selectedIndex), ...options.slice(selectedIndex + 1)];
	}

	return options;
};

/**
 * Get the first available business unit
 */
export const getFirstBusinessUnit = (units: BusinessUnit[]): string | null => {
	return units.length > 0 ? units[0].id : null;
};

/**
 * Validate if a business unit ID exists in the available units
 */
export const isValidBusinessUnitId = (unitId: string, availableUnits: BusinessUnit[]): boolean => {
	return availableUnits.some((unit) => unit.id === unitId);
};

/**
 * Find business unit by ID
 */
export const findBusinessUnitById = (
	unitId: string,
	businessUnits: BusinessUnit[]
): BusinessUnit | null => {
	return businessUnits.find((unit) => unit.id === unitId) || null;
};
